(function () {
  var ROOT_SELECTOR = '[data-ats-collection-root]';

  if (window.ATSCollectionGrid && window.ATSCollectionGrid.initAll) {
    window.ATSCollectionGrid.initAll();
    return;
  }

  var instances = new WeakMap();

  function createInstance(initialRoot) {
    var sectionId = initialRoot.getAttribute('data-section-id');
    var multiSectionTabEnabled =
      initialRoot.getAttribute('data-multisection-tab') === 'true';

    /* =========================
       PICK CURRENT DOM (theme can replace it via AJAX)
       ========================= */
    function pick() {
      var root = document.getElementById('ATS-CollectionWrapper-' + sectionId);
      if (!root) return null;

      var grid = root.querySelector('#ATS-CollectionGrid-' + sectionId);
      if (!grid) return null;

      return {
        root: root,
        grid: grid,
        sortSelect: root.querySelector('[data-ats-sort-select]'),
        countEl: root.querySelector('[data-ats-count]')
      };
    }

    var ctx = pick();
    if (!ctx) return;

    var root = ctx.root;
    var grid = ctx.grid;
    var sortSelect = ctx.sortSelect;
    var countEl = ctx.countEl;

    var consumerPaginationEnabled =
      root.getAttribute('data-consumer-pagination') === 'true';
    var consumerPageHTML = '';
    var fullCatalogHTML = '';

    /* =========================
       BASE + CACHES
       ========================= */
    // baseAllHTML = full consumer-visible catalog (all Shopify chunks merged)
    var baseAllHTML = consumerPaginationEnabled ? '' : grid.innerHTML;
    var allHTML = baseAllHTML;

    var bestHTML = null;
    var tagIndexAll = null;

    var tagHTML_all = {};   // tag => filtered HTML from allHTML
    var tagHTML_best = {};  // tag => filtered HTML from bestHTML

    function n(s) {
      return (s || '').toLowerCase().trim().replace(/\s+/g, ' ');
    }

    /** Match tab keys to product tags (downcase; keep spaces — do not handleize). */
    function tagKey(s) {
      return n(s);
    }

    function getTabs() {
      // ✅ re-query tabs because theme can replace them
      return root.querySelectorAll('[data-ats-tab]');
    }

    function setActiveTabsUI(selected) {
      getTabs().forEach(function (t) {
        var k = tagKey(t.getAttribute('data-ats-tab'));
        t.classList.toggle('ats-tab--active', !!selected[k]);
      });
    }

    function setGridFilteringUI(isFiltering) {
      if (isFiltering) grid.classList.add('ats-tab-filtering');
      else grid.classList.remove('ats-tab-filtering');
    }

    /* =========================
       ✅ COUNT: always from live DOM
       ========================= */

    function updateCountFromDOM() {
    if (!countEl || !grid) return;
    var total = grid.querySelectorAll('[data-ats-product-card]').length;
    countEl.textContent = total + ' Products';
  }

  /* ✅ Add this here */
  function sortSoldOutLastInDOM() {
    if (!grid) return;

    var items = [];

    grid.querySelectorAll('[data-ats-product-card]').forEach(function (card) {

      var item =
        card.closest('[data-ats-pinned-product]') ||
        card.closest('.grid__item') ||
        card;

      if (items.indexOf(item) === -1) {
        items.push(item);
      }
    });

    var availableItems = [];
    var soldOutItems = [];

    items.forEach(function (item) {
      var card = item.matches('[data-ats-product-card]')
        ? item
        : item.querySelector('[data-ats-product-card]');

      if (!card) return;

      if (card.getAttribute('data-ats-available') === 'false') {
        soldOutItems.push(item);
      } else {
        availableItems.push(item);
      }
    });

    availableItems.concat(soldOutItems).forEach(function (item) {
      grid.appendChild(item);
    });
  }

    function applyConsumerIndex(detail) {
      if (!detail || String(detail.sectionId) !== sectionId) return;
      fullCatalogHTML = detail.fullVisibleHTML || '';
      consumerPageHTML = detail.consumerPageHTML || '';
      baseAllHTML = fullCatalogHTML;
      allHTML = consumerPageHTML;
      tagIndexAll = null;
      tagHTML_all = {};
      tagHTML_best = {};
      sortSoldOutLastInDOM();
      updateCountFromDOM();
    }

    function renderEmptyState(message) {
      var empty = document.createElement('div');
      var title = document.createElement('div');
      var text = document.createElement('div');

      empty.className = 'ats-empty';
      title.className = 'ats-empty__title';
      text.className = 'ats-empty__text';

      title.textContent = message || 'No products found';
      text.textContent = 'Try changing filters or selecting another tab.';

      empty.appendChild(title);
      empty.appendChild(text);
      grid.innerHTML = '';
      grid.appendChild(empty);

      updateCountFromDOM();
    }

    function ATS_getFeaturedSortValue() { return 'manual'; }

    function ATS_syncSortDropdown(sortKey, forceFeatured) {
      if (!sortSelect) return;

      var def = sortSelect.getAttribute('data-default-sortby') || '';
      var featured = ATS_getFeaturedSortValue();

      var target;
      if (forceFeatured) target = featured;
      else target = (!sortKey || sortKey === 'all') ? (def || featured) : sortKey;

      var has = Array.from(sortSelect.options).some(function (opt) {
        return opt.value === target;
      });

      if (!has) {
        var hasFeatured = Array.from(sortSelect.options).some(function (opt) {
          return opt.value === featured;
        });
        target = hasFeatured ? featured : def;
      }

      sortSelect.value = target;

      var placeholder = sortSelect.querySelector('option[value=""]');
      if (placeholder) placeholder.remove();
    }

    function updateBrowserUrl(sortKey) {
      try {
        var pageUrl = new URL(window.location.href);
        pageUrl.searchParams.delete('section_id');
        if (!sortKey || sortKey === 'all') pageUrl.searchParams.delete('sort_by');
        else pageUrl.searchParams.set('sort_by', sortKey);
        history.replaceState({}, '', pageUrl.toString());
      } catch (e) {}
    }

    function extractId(card) {
      return card.getAttribute('data-product-id') || null;
    }

    function selectedTagsArray(selected) {
      return Object.keys(selected)
        .filter(function (k) { return k !== 'all' && k !== 'bestseller'; })
        .map(n);
    }

    async function fetchGridInnerHTML(sortKey) {
      var pageUrl = new URL(window.location.href);
      pageUrl.searchParams.delete('section_id');

      if (!sortKey || sortKey === 'all') pageUrl.searchParams.delete('sort_by');
      else pageUrl.searchParams.set('sort_by', sortKey);

      var fetchUrl = new URL(pageUrl.toString());
      fetchUrl.searchParams.set('section_id', sectionId);

      var res = await fetch(fetchUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('#ATS-CollectionGrid-' + sectionId);
      return newGrid ? newGrid.innerHTML : null;
    }

    async function ensureAllBase(forceFetch) {
      if (consumerPaginationEnabled && fullCatalogHTML) {
        baseAllHTML = fullCatalogHTML;
        allHTML = fullCatalogHTML;
        return;
      }
      if (!forceFetch) {
        allHTML = baseAllHTML;
        return;
      }
      baseAllHTML = await fetchGridInnerHTML('all');
      allHTML = baseAllHTML;
    }

    async function ensureBestBase() {
      if (bestHTML) return;
      bestHTML = await fetchGridInnerHTML('best-selling');
    }

    function buildTagIndexAll() {
      if (!allHTML) return null;
      if (tagIndexAll) return tagIndexAll;

      var temp = document.createElement('div');
      temp.innerHTML = allHTML;

      var idx = {};
      temp.querySelectorAll('[data-ats-product-card]').forEach(function (card) {
        var id = extractId(card);
        if (!id) return;

        var tags = (card.getAttribute('data-ats-tags') || '')
          .split(',')
          .map(n)
          .filter(Boolean);

        tags.forEach(function (t) {
          var key = tagKey(t);
          if (!key) return;
          if (!idx[key]) idx[key] = new Set();
          idx[key].add(id);
        });
      });

      tagIndexAll = idx;
      return tagIndexAll;
    }

    function getAllowedIdsForTags(tagsArr) {
      if (!tagsArr || tagsArr.length === 0) return null;
      var idx = buildTagIndexAll();
      if (!idx) return null;

      var out = new Set();
      tagsArr.forEach(function (t) {
        var set = idx[tagKey(t)];
        if (!set) return;
        set.forEach(function (id) { out.add(id); });
      });
      return out;
    }

    function buildFilteredHTML(baseHTML, allowedIds) {
      if (!baseHTML) return '';
      if (!allowedIds) return baseHTML;
      if (allowedIds.size === 0) return '';

      var temp = document.createElement('div');
      temp.innerHTML = baseHTML;

      temp.querySelectorAll('[data-ats-product-card]').forEach(function (card) {
        var id = extractId(card);
        if (!id || !allowedIds.has(id)) card.remove();
      });

      return temp.innerHTML;
    }

    function mergeHTMLBlocksUnique(htmlList) {
      var seen = new Set();
      var temp = document.createElement('div');
      var out = [];

      (htmlList || []).forEach(function (html) {
        if (!html) return;

        temp.innerHTML = html;
        temp.querySelectorAll('[data-ats-product-card]').forEach(function (card) {
          var id = extractId(card);
          if (!id) return;
          if (seen.has(id)) return;
          seen.add(id);
          out.push(card.outerHTML);
        });
      });

      return out.join('');
    }

    function renderHTML(html) {
      grid.innerHTML = html || '';
      sortSoldOutLastInDOM();
      updateCountFromDOM();
    }

    /* =========================
       STATE
       ========================= */
    var selected = { all: true };

    function toggleSelection(key) {
      // All always resets the complete selection.
      if (key === 'all') {
        selected = { all: true };
        return;
      }

      // Setting OFF: remove the previous tab and keep only the clicked tab.
      if (!multiSectionTabEnabled) {
        selected = {};
        selected[key] = true;
        return;
      }

      // Setting ON: allow multiple tabs to remain selected.
      delete selected.all;

      if (selected[key]) {
        delete selected[key];
      } else {
        selected[key] = true;
      }

      if (Object.keys(selected).length === 0) {
        selected = { all: true };
      }
    }

    async function applyState() {
      if (consumerPaginationEnabled && !fullCatalogHTML) return;

      var isAll = !!selected.all;
      var isBest = !!selected.bestseller;
      var tagsArr = selectedTagsArray(selected);

      await ensureAllBase(false);
      buildTagIndexAll();

      // ✅ ALL
      if (isAll) {
        setGridFilteringUI(false);
        renderHTML(consumerPaginationEnabled ? consumerPageHTML : allHTML);

        ATS_syncSortDropdown('all', true);
        updateBrowserUrl('all');
        return;
      }

      // ✅ TAGS only (from ALL base)
      if (!isBest) {
        setGridFilteringUI(true);

        if (tagsArr.length === 1) {
          var t1 = tagsArr[0];

          if (!tagHTML_all[t1]) {
            var allowed1 = getAllowedIdsForTags([t1]);
            tagHTML_all[t1] = buildFilteredHTML(allHTML, allowed1);
          }

          if (!tagHTML_all[t1] || tagHTML_all[t1].trim() === '') {
            renderEmptyState('No products found for "' + t1 + '"');
            ATS_syncSortDropdown('all', true);
            updateBrowserUrl('all');
            return;
          }

          renderHTML(tagHTML_all[t1]);
        } else {
          tagsArr.forEach(function (t) {
            if (!tagHTML_all[t]) {
              var allowedT = getAllowedIdsForTags([t]);
              tagHTML_all[t] = buildFilteredHTML(allHTML, allowedT);
            }
          });

          var merged = mergeHTMLBlocksUnique(tagsArr.map(function (t) { return tagHTML_all[t]; }));

          if (!merged || merged.trim() === '') {
            renderEmptyState('No products found for selected tabs');
            ATS_syncSortDropdown('all', true);
            updateBrowserUrl('all');
            return;
          }

          renderHTML(merged);
        }

        ATS_syncSortDropdown('all', true);
        updateBrowserUrl('all');
        return;
      }

      // ✅ BEST mode
      await ensureBestBase();

      // BEST only
      if (!tagsArr.length) {
        setGridFilteringUI(false);
        renderHTML(bestHTML);

        ATS_syncSortDropdown('best-selling', false);
        updateBrowserUrl('best-selling');
        return;
      }

      // BEST + TAGS
      setGridFilteringUI(false);

      if (tagsArr.length === 1) {
        var tb = tagsArr[0];

        if (!tagHTML_best[tb]) {
          var allowedB = getAllowedIdsForTags([tb]);
          tagHTML_best[tb] = buildFilteredHTML(bestHTML, allowedB);
        }

        if (!tagHTML_best[tb] || tagHTML_best[tb].trim() === '') {
          renderEmptyState('No products found for "' + tb + '"');
          ATS_syncSortDropdown('best-selling', false);
          updateBrowserUrl('best-selling');
          return;
        }

        renderHTML(tagHTML_best[tb]);
      } else {
        tagsArr.forEach(function (t) {
          if (!tagHTML_best[t]) {
            var allowedBT = getAllowedIdsForTags([t]);
            tagHTML_best[t] = buildFilteredHTML(bestHTML, allowedBT);
          }
        });

        var mergedBest = mergeHTMLBlocksUnique(tagsArr.map(function (t) { return tagHTML_best[t]; }));

        if (!mergedBest || mergedBest.trim() === '') {
          renderEmptyState('No products found for selected tabs');
          ATS_syncSortDropdown('best-selling', false);
          updateBrowserUrl('best-selling');
          return;
        }

        renderHTML(mergedBest);
      }

      ATS_syncSortDropdown('best-selling', false);
      updateBrowserUrl('best-selling');
    }

    /* =========================
       INIT
       ========================= */
    (function init() {
      if (!consumerPaginationEnabled) {
        updateCountFromDOM();
      }

      var url = new URL(window.location.href);
      var sortBy = url.searchParams.get('sort_by');

      if (sortBy === 'best-selling') {
        selected = { bestseller: true };
        setActiveTabsUI(selected);
        bestHTML = grid.innerHTML;
        ATS_syncSortDropdown('best-selling', false);
        return;
      }

      selected = { all: true };
      setActiveTabsUI(selected);
      ATS_syncSortDropdown('all', true);
    })();


    function handleConsumerPagination(detail) {
      applyConsumerIndex(detail);

      var url = new URL(window.location.href);
      if (url.searchParams.get('sort_by') === 'best-selling') return;

      selected = { all: true };
      setActiveTabsUI(selected);
      setGridFilteringUI(false);
    }

    /* =========================
       ✅ AFTER SHOPIFY FILTER AJAX UPDATE
       (requires you dispatch ATS:COLLECTION_UPDATED in theme.js)
       ========================= */
    function resetAfterFiltersAjax() {
      var newCtx = pick();
      if (!newCtx) return;

      root = newCtx.root;
      grid = newCtx.grid;
      sortSelect = newCtx.sortSelect;
      countEl = newCtx.countEl;
      consumerPaginationEnabled =
        root.getAttribute('data-consumer-pagination') === 'true';

      if (consumerPaginationEnabled) {
        fullCatalogHTML = '';
        consumerPageHTML = '';
        baseAllHTML = '';
        allHTML = '';
      } else {
        baseAllHTML = grid.innerHTML;
        allHTML = baseAllHTML;
      }

      bestHTML = null;
      tagIndexAll = null;
      tagHTML_all = {};
      tagHTML_best = {};

      selected = { all: true };
      setActiveTabsUI(selected);
      setGridFilteringUI(false);

      if (!consumerPaginationEnabled) {
        updateCountFromDOM();
      }
    }

      async function handleTabClick(tab) {
        if (!root || !document.body.contains(root)) {
          var latest = pick();
          if (!latest) return;

          root = latest.root;
          grid = latest.grid;
          sortSelect = latest.sortSelect;
          countEl = latest.countEl;
        }

        if (!root.contains(tab)) return;

        var key = tagKey(tab.getAttribute('data-ats-tab'));

        toggleSelection(key);
        setActiveTabsUI(selected);

        await applyState();

        // Pinned products only show in ALL tab
        if (key === 'all') {
          grid.querySelectorAll('[data-ats-pinned-product]').forEach(function(product) {
            product.style.display = '';
          });
        } else {
          grid.querySelectorAll('[data-ats-pinned-product]').forEach(function(product) {
            product.style.display = 'none';
          });
        }
      }

    return {
      handleConsumerPagination: handleConsumerPagination,
      handleTabClick: handleTabClick,
      resetAfterFiltersAjax: resetAfterFiltersAjax
    };
  }

  function initRoot(root) {
    if (!root) return null;

    var instance = instances.get(root);
    if (!instance) {
      instance = createInstance(root);
      instances.set(root, instance);
    }

    return instance;
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  function getEventRoots(detail) {
    if (detail && detail.sectionId) {
      var root = document.getElementById(
        'ATS-CollectionWrapper-' + String(detail.sectionId)
      );
      return root ? [root] : [];
    }

    return Array.from(document.querySelectorAll(ROOT_SELECTOR));
  }

  window.ATSCollectionGrid = {
    initAll: initAll
  };

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-ats-sort-select]');
    if (!select) return;

    var placeholder = select.querySelector('option[value=""]');
    if (placeholder) placeholder.remove();
  });

  document.addEventListener(
    'click',
    async function (event) {
      var tab = event.target.closest('[data-ats-tab]');
      if (!tab) return;

      var root = tab.closest(ROOT_SELECTOR);
      if (!root) return;

      event.preventDefault();

      var instance = initRoot(root);
      if (instance) await instance.handleTabClick(tab);
    },
    true
  );

  document.addEventListener('ATS:CONSUMER_PAGINATION_READY', function (event) {
    var detail = event.detail || {};
    var root = document.getElementById(
      'ATS-CollectionWrapper-' + String(detail.sectionId || '')
    );
    var instance = initRoot(root);

    if (instance) instance.handleConsumerPagination(detail);
  });

  document.addEventListener('ATS:COLLECTION_UPDATED', function (event) {
    initAll();

    getEventRoots(event.detail || {}).forEach(function (root) {
      var instance = initRoot(root);
      if (instance) instance.resetAfterFiltersAjax();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
